import { API_BASEURL } from '@/utils/config/env';
import Axios from 'axios';
import { getCookie } from 'cookies-next';
import { gethandshakeApiRoute, getServerHandshake } from './global/handshake';
import { isFailedBody, noteApiFailure } from '@/utils/gtm/api-failures';

const axios = Axios.create({
  baseURL: API_BASEURL,

  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

let handshakePromise = null;

async function getClientHandshake() {
  if (handshakePromise) return handshakePromise;

  handshakePromise = gethandshakeApiRoute()
    .then((res) => res?.data || null)
    .finally(() => {
      handshakePromise = null;
    });

  return handshakePromise;
}

axios.interceptors.request.use(
  async (config) => {
    let handshake;
    if (typeof window !== 'undefined') {
      const locale = getCookie('NEXT_LOCALE') || 'ar';
      handshake = getCookie(`inohs_${locale}`);
    } else {
      handshake = await getServerHandshake();
    }

    if (typeof window !== 'undefined' && !handshake) {
      handshake = await getClientHandshake();
    }

    const isV1 = config?.baseURL?.includes('v1');

    if (handshake && isV1) {
      config.headers['Authorization'] = `Bearer ${handshake}`;
    }
    return config;
  },
  (err) => Promise.reject('Error in axios config', err)
);

axios.interceptors.response.use(
  (res) => {
    if (isFailedBody(res.data))
      noteApiFailure({ status: res.status, body: res.data });
    return Promise.resolve({
      data: res.data,
      error: null,
      status: res.status,
      // headers: res.headers,
    });
  },
  (error) => {
    if (error.response) {
      console.log(
        '❌❌❌ api response error________________________ :',
        error.response.status,
        '--->',
        error.config
      );
      noteApiFailure({
        status: error.response.status,
        body: error.response?.data,
      });
      return Promise.reject({
        data: null,
        error: error.response?.data,
        status: error.response.status,
      });
    } else if (error.request) {
      console.log(
        '❌❌❌ api request error________________________ :',
        error.request.status,
        ' ---> ',
        error.config
      );
      noteApiFailure({ status: error.request.status, fallback: 'NETWORK_ERROR' });
      return Promise.reject({
        data: null,
        error: error.request?.data,
        status: error.request.status,
      });
    } else {
      console.log(
        '❌❌❌ api request error________________________ :',
        500,
        '--->',
        error
      );
      return Promise.reject({
        data: null,
        error: error,
        status: 500,
      });
    }
  }
);

export default axios;
